export const ROLE = [
    'ADMIN', 'VIGILANTE', 'SUPERVISOR', 'COMERCIAL', 'TECNOLOGIA', 'GERENCIA', 'COORDINADOR', 'OPERADOR'
];

export const TYPE_VIGILANTE = [
    'FIJO', 'RELEVANTE', 'DISPONIBLE', 'NO_APLICA'
];

export const TURNO = [
    'DIURNO', 'NOCTURNO', 'NO_APLICA'
];

export const CARGO_VIGILANTE = [
    'PORTERIA', 'VEHICULAR', 'RECORREDOR'
];


//area

export const TIPO_AREA = [
    'CONDOMINIO', 'ZONA_GEOGRAFICA', 'EDIFICIO', 'EMPRESA'
];